import type { TreatmentOffer } from "@/services/commerceOffers";
import type { ProgramOffer } from "@/services/commerceProgramOffers";
import {
  DESTINATION_FULLSTORY,
  DESTINATION_POSTHOG,
  trackCustomEvent,
} from "@/utils/analytics/tracking";

// Evvy Eventing sheet, "Internal Product (fullstory)" tab.
export const CARD_EVENTS = {
  viewed: "EvvyAI Chat - View Product Card",
  addClicked: "EvvyAI Chat - Clicked Add to Cart",
  added: "EvvyAI Chat - Added to Cart",
  detailsClicked: "EvvyAI Chat - Clicked View Details",
} as const;

/** Where the member saw the card: a live answer, or a refreshed past conversation. */
export type CardSource = "live" | "history";

type CardOffer = Pick<TreatmentOffer | ProgramOffer, "kind" | "product_slug">;

// product is the slug Shop Care sends (an Rx slug, op-4, ctp); never member data.
export const trackCardEvent = (
  event: keyof typeof CARD_EVENTS,
  { kind, product_slug }: CardOffer,
  source: CardSource,
  counts?: { itemsAdded: number; itemsShown: number }
): void =>
  trackCustomEvent(
    CARD_EVENTS[event],
    {
      product: product_slug,
      cardType: kind === "program" ? "plan" : "product",
      source,
      ...counts,
    },
    [DESTINATION_FULLSTORY, DESTINATION_POSTHOG]
  );

// Viewed fires once per card per page load, not on every sidebar remount.
const viewedCards = new Set<string>();
export const trackCardViewed = (
  cardKey: string,
  offer: CardOffer,
  source: CardSource
): void => {
  if (viewedCards.has(cardKey)) return;
  viewedCards.add(cardKey);
  trackCardEvent("viewed", offer, source);
};
